import './wdyr'; // <--- first import
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@Core/App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { store } from './Core/Redux/Store'
import './i18n'
import Logger from '@Common/Utils/Logger'

// MSAL imports
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '@Auth/Services/Msal'

Logger.info('Initializing OTA UI application')

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </Provider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
